//
//
//
//

import RolChip from './RolChip'
import RolSelectDialog from './RolSelectDialog'
import UsuarioRol from '@/api/promotores/usuarios/roles.api'

export default {
  components: { RolChip },
  props: {
    value: {
      type: Object | undefined,
      required: true
    },
    promotorId: {
      type: Number | undefined,
      required: true
    }
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    rol: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },

  methods: {
    async edit() {
      const dialog = this.$q.dialog({
        component: RolSelectDialog,
        rolId: this.rol.id
      })

      dialog.onOk(async (rol) => {
        try {
          this.loading = true
          await UsuarioRol.update(this.promotorId, rol.id)
          this.rol = rol
          dialog.hide()
        } finally {
          this.loading = false
        }
      })
    }
  }
}
